import { Badge } from '../../../../../../components/atoms/badge/badge';

interface Props {
  ativo: boolean;
}

export const ProdutoStatusBadge = ({ ativo }: Props) =>
  ativo ? (
    <Badge variant="success">Ativo</Badge>
  ) : (
    <Badge variant="neutral">Inativo</Badge>
  );
